// --------------------------------------------------------
// EVOLUCAO FIELD - EvolucaoField
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Autocomplete, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { H3 } from '../../../../../../../components/UI/generalLayout/Layout.styled'
import { AppointmentService } from '../../../../../../../core/http/service/AppointmentService';
import useResponsiveInfo from '../../../../../../../hooks/useResponsiveInfo';
import { MediumInput } from '../DetailsAttendanceRecord.styled'
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// EVOLUCAO FIELD INTERFACE
// --------------------------------------------------------

interface IEvolucaoField {
    evolucao: any;
    isViewState: boolean;
    setEvolucaoObject: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const EvolucaoField = ({ evolucao, setEvolucaoObject, isViewState }: IEvolucaoField) => {
    // --------------------------------------------------------
    // EVOLUCAO FIELD PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo();
    const [cidOptions, setCidOptions] = useState<any[]>([])
    // --------------------------------------------------------

    const fetchCidOptions = async (event: any, newValue: any | null)=>{
        const service: AppointmentService = new AppointmentService();
        const result: any = await service.getCIDByNameOrCode(newValue)

        setCidOptions(result.data.data)

        
    }

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <div>
                <H3>Subjetivo</H3>
                <MediumInput
                    disabled={isViewState}
                    value={evolucao.subjetivo}
                    onChange={(event: any) => {
                        setEvolucaoObject((prev: any) => {
                            return { ...prev, subjetivo: event.target.value }
                        })
                    }}
                    placeholder="Digite sobre o subjetivo"
                />
            </div>
            <div>
                <H3>Objetivo</H3>
                <MediumInput
                    value={evolucao.objetivo}
                    disabled={isViewState}
                    onChange={(event: any) => {
                        setEvolucaoObject((prev: any) => {
                            return { ...prev, objetivo: event.target.value }
                        })
                    }}
                    placeholder="Digite sobre o objetivo" />
            </div>
            <div>
                <H3>Avaliação</H3>
                <MediumInput
                    disabled={isViewState}
                    value={evolucao.avaliacao}
                    onChange={(event: any) => {
                        setEvolucaoObject((prev: any) => {
                            return { ...prev, avaliacao: event.target.value }
                        })
                    }}
                    placeholder="Digite sobre a avaliacao" />
            </div>
            <div style={{ display: 'flex', flexDirection:'column', gap: 12 }}>
                <div>
                    <H3>CID principal</H3>
                    <Autocomplete
                        renderInput={(params) => (
                            <TextField {...params} label="Selecione o CID" style={{ width: '100%' }} />
                        )} 
                        options={cidOptions}
                        filterOptions={(x) => x}
                        autoComplete
                        disabled={isViewState}
                        includeInputInList
                        filterSelectedOptions
                        getOptionLabel={(option)=> option.descricao === ''? option.codigo : option.descricao}
                        value={evolucao.cidPrincipal}
                        noOptionsText="Nenhum CID encontrado"
                        onInputChange={(event, newInputValue) => {
                            if(newInputValue.length >= 3){
                                fetchCidOptions(event, newInputValue)
                            }
                          }}
                        onChange={(event, newValue)=>{ setEvolucaoObject((prev: any)  => {
                            return { ...prev, cidPrincipal: newValue }
                        }) }}
                    />
                </div>
                <div>
                    <H3>{'CID secundário (opcional)'}</H3>
                    <Autocomplete
                        renderInput={(params) => (
                            <TextField {...params} label="Selecione o CID" style={{ width: '100%' }} />
                        )} 
                        options={cidOptions}
                        filterOptions={(x) => x}
                        autoComplete
                        disabled={isViewState}
                        includeInputInList
                        filterSelectedOptions
                        getOptionLabel={(option)=> option.descricao === ''? option.codigo : option.descricao}
                        value={evolucao.cidSecundario}
                        noOptionsText="Nenhum CID encontrado"
                        onInputChange={(event, newInputValue) => {
                            if(newInputValue.length >= 3){
                                fetchCidOptions(event, newInputValue)
                            }
                          }}
                        onChange={(event, newValue)=>{ setEvolucaoObject((prev: any)  => {
                            return { ...prev, cidSecundario: newValue }
                        }) }}
                    />
                </div>
            </div>
            <div>
                <H3>Plano</H3>
                <MediumInput
                    value={evolucao.plano}
                    disabled={isViewState}
                    onChange={(event: any) => {
                        setEvolucaoObject((prev: any) => {
                            return { ...prev, plano: event.target.value }
                        })
                    }}
                    placeholder="Digite sobre a avaliacao" />
            </div>
        </>
    )
    // --------------------------------------------------------
}

export default EvolucaoField